/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationDetailsBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationDetailsBaseRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationDetailsBaseRequest>): ScheduleRecommendationDetailsBaseRequest {
        let obj = Object.assign(new ScheduleRecommendationDetailsBaseRequest(), model);
        ScheduleRecommendationDetailsBaseRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationDetailsBaseRequest>): ScheduleRecommendationDetailsBaseRequest {
        if (!model) return null;
        return ScheduleRecommendationDetailsBaseRequest.newInstance(<ScheduleRecommendationDetailsBaseRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationDetailsBaseRequest) {
        if (!obj) return;

        models.ScheduleRecommendationDetailsBaseRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationDetailsBaseRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationDetailsBaseRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant Id
     */
    tenant_id: string;

    /**
     * Service Account Id
     */
    service_account_id: string;

    /**
     * Unique Resource Id of Inventory
     */
    resource_id: string;

    /**
     * Schedule Finding Type
     */
    schedule_finding: models.ScheduleFinding;

}
